var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "33px",
    viewBox: "0 0 41 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3120AD16-B199-4512-BFB8-9E5FACBD85AD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BBFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CDFE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Requirement-Popup",
    transform: "translate(-280.000000, -700.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(208.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tweet",
    transform: "translate(52.000000, 480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitter-Icon",
    transform: "translate(20.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.985952,8.19399328 C19.985952,8.83683821 20.058899,9.4614464 20.1990939,10.0621189 L20.1990939,10.0621189 C13.3785547,9.72018009 7.33079729,6.4592238 3.28338177,1.49997151 L3.28338177,1.49997151 C2.57898786,2.71157463 2.17322049,4.11808286 2.17322049,5.61919416 L2.17322049,5.61919416 C2.17322049,8.46298513 3.62076138,10.9716761 5.8251268,12.4397333 L5.8251268,12.4397333 C4.47902775,12.3987006 3.21385422,12.0294067 2.10711233,11.4150567 L2.10711233,11.4150567 C2.10597253,11.4492506 2.10597253,11.4834445 2.10597253,11.5199179 L2.10597253,11.5199179 C2.10597253,15.4886875 4.93494614,18.8020744 8.68943409,19.5532 L8.68943409,19.5532 C8.00099732,19.7401265 7.27494728,19.8415684 6.52610133,19.8415684 L6.52610133,19.8415684 C5.99723599,19.8415684 5.48318801,19.7891377 4.98395737,19.6933949 L4.98395737,19.6933949 C6.02801049,22.9486522 9.05758819,25.318288 12.6502251,25.3843962 L12.6502251,25.3843962 C9.84062803,27.5830626 6.30270132,28.8926882 2.45816949,28.8926882 L2.45816949,28.8926882 C1.79594803,28.8926882 1.14170513,28.8550749 0.5,28.7787086 L0.5,28.7787086 C4.13252978,31.1038924 8.44437796,32.4591098 13.0787884,32.4591098 L13.0787884,32.4591098 C28.1742463,32.4591098 36.4286488,19.9726449 36.4286488,9.14458312 L36.4286488,9.14458312 C36.4286488,8.79010657 36.42181,8.43676982 36.4058529,8.08457286 L36.4058529,8.08457286 C38.0072662,6.92881974 39.4012367,5.48583803 40.5,3.84339203 L40.5,3.84339203 C39.0296632,4.49421554 37.4464866,4.93531658 35.7869436,5.13250128 L35.7869436,5.13250128 C37.4806805,4.11808286 38.7823275,2.51325013 39.3955377,0.599532684 L39.3955377,0.599532684 C37.8100815,1.53872457 36.0536559,2.22146236 34.1843905,2.58847666 L34.1843905,2.58847666 C32.6866986,0.996181683 30.5541403,0 28.1936228,0 L28.1936228,0 C23.661794,0 19.985952,3.67014304 19.985952,8.19399328",
    id: "Fill-7"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.add32202.svg";
export { ForwardRef as ReactComponent };